export default __webpack_public_path__ + "static/2019_16-d5f631adca203e6be88a453b07554d63.png";